import { Device, RefactoredDevice } from '../../../@types/model/device';
import { DeliveryRequest } from '../../../@types/model/deliveryRequest';
import dayjs from 'dayjs';

const refactorDevices = (devices: Device[], deliveryRequests: DeliveryRequest[] = []) => {
  let refactoredDevices: RefactoredDevice[] = [];

  devices.forEach((dg) => {
    let percent: number = 0;
    let temperature = 0;
    let rawSensor = 0;
    let volume = 0;
    let remain = 0;
    let weightC = 0;
    let cumulative_flow = 0;
    let numero_de_crianza = '';
    let tipo_de_producto = '';
    let last_revision: string = '';
    let next_revision: string = '';
    let sector: number = -1;
    let calibrado: boolean = true;
    let thereIsRemainValue = false;
    let thereIsWeightCValue = false;
    dg.attributes.last_data?.data.forEach((dat) => {
      switch (dat.name) {
        case 'Percent':
          percent = parseFloat(dat.value);
          break;
        case 'Temperature':
          temperature = parseFloat(dat.value);
          break;
        case 'RawSensor':
          rawSensor = parseFloat(dat.value);
          break;
        case 'Volume':
          volume = parseFloat(dat.value);
          break;
        case 'cumulative_flow':
          cumulative_flow = parseFloat(dat.value);
          break;
        case 'Remain':
          thereIsRemainValue = true;
          remain = parseFloat(dat.value);
          break;
        case 'WeightC':
          thereIsWeightCValue = true;
          weightC = parseFloat(dat.value);
          break;
      }
    });
    // Check if the device is Caudalimetro Type (flowmeter)
    let capacidad: number = 0;
    if (dg.attributes.parameters) {
      for (var k in dg.attributes.parameters) {
        if (dg.attributes.parameters.hasOwnProperty(k)) {
          switch (dg.attributes.parameters[k].identifier) {
            case 'capacidad':
              capacidad = parseFloat(parseFloat(dg.attributes.parameters[k].value).toFixed(2));
              break;
          }
        }
      }
    }
    if (capacidad !== 0 && cumulative_flow !== 0) {
      thereIsRemainValue = true;
      // remain = capacidad - cumulative_flow;
      percent = ((capacidad - cumulative_flow) / capacidad) * 100;
    }
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;
    if (dg.attributes.parameters) {
      for (var k2 in dg.attributes.parameters) {
        if (dg.attributes.parameters.hasOwnProperty(k2)) {
          switch (dg.attributes.parameters[k2].identifier) {
            case 'capacidad':
              capacidad = parseFloat(parseFloat(dg.attributes.parameters[k2].value).toFixed(2));
              break;
            case 'numero_de_crianza':
              numero_de_crianza = dg.attributes.parameters[k2].value;
              break;
            case 'tipo_de_producto':
              tipo_de_producto = dg.attributes.parameters[k2].value;
              break;
            case 'sector':
              sector = parseInt(dg.attributes.parameters[k2].value);
              break;
            case 'last_revision':
              last_revision = dg.attributes.parameters[k2].value;
              break;
            case 'next_revision':
              next_revision = dg.attributes.parameters[k2].value;
              break;
            case 'calibrado':
              calibrado = dg.attributes.parameters[k2].value;
              break;
          }
        }
      }
    }

    if (dg.attributes.device_type === 'preset:gespasa:diesel-plus-meter') {
      if (percent === 0) {
        if (capacidad !== 0) {
          percent = (volume / capacidad) * 100;
          remain = volume;
        }
      }
    } else {
      // Como remain manda sobre percent, debemos asignar percent el valor correcto.
      if (capacidad !== 0) {
        if (remain !== 0) {
          percent = (remain / capacidad) * 100;
        }
      }
    }

    if (percent > 100) percent = 100;
    if (remain && capacidad) {
      if (remain > capacidad) remain = capacidad;
    }

    if (!thereIsRemainValue && thereIsWeightCValue) {
      if (weightC <= capacidad) remain = weightC;
      else remain = capacidad;
    }

    let device_type = 'deposito';
    let unit = 'L';
    switch (dg.attributes.device_type) {
      case 'preset:metrosil-v1':
        device_type = 'silo';
        unit = 'Kg';
        break;
      case 'preset:ocr-device-type:meter':
        device_type = 'glp';
        break;
      case 'preset:ocr-device-type:water':
        device_type = 'water';
        break;
      case 'preset:trackgas-flow-sensor-v1':
        device_type = 'glp';
        unit = 'Kg';
        break;
    }

    const backgroundPercent =
      percent < 30 ? 'rgb(222 68 68)' : percent < 60 ? '#fdc867' : '#77cc77';
    const colorPercent = percent < 30 ? 'black' : percent < 60 ? 'black' : 'black';

    let delivery_request_pending: DeliveryRequest[] | null = deliveryRequests.filter(
      (deliveryRequest: DeliveryRequest) => {
        if (deliveryRequest.items?.length) {
          if (
            dayjs(deliveryRequest.delivery_date).diff(dayjs().format('YYYY-MM-DD HH:mm'), 'hour') >
            0
          ) {
            return deliveryRequest.items.filter((item) => {
              let is_ref_of = dg.attributes.is_ref_of;
              if (dg.attributes.is_ref_of.split(':').length === 3)
                is_ref_of = dg.attributes.is_ref_of.split(':')[2];
              if (item.device === dg.guid || item.device === is_ref_of) return true;
              return false;
            }).length;
          }
        }
        return false;
      }
    );

    let refactoredDevice: RefactoredDevice = {
      ...dg,
      backgroundPercent: backgroundPercent,
      colorPercent: colorPercent,
      percent: percent,
      volumen_aproximado: remain,
      volumen_libre: capacidad - remain,
      device_type: device_type,
      capacidad: capacidad,
      temperature: temperature,
      rawSensor: rawSensor,
      slotsNumber: 0,
      unit: unit,
      numero_de_crianza: numero_de_crianza,
      tipo_de_producto: tipo_de_producto,
      sector: sector,
      last_revision: last_revision,
      next_revision: next_revision,
      productSchedule: null,
      calibrado: calibrado,
      delivery_request_pending: delivery_request_pending
    };
    refactoredDevices.push(refactoredDevice);
  });
  return refactoredDevices;
};

export default refactorDevices;
